import { UserServiceActionTypes } from '../User/User.types'
import * as LessonTypes from './Lesson.types'

export const lessonInitialState: LessonTypes.LessonState = {
  lessonsTemplates: [],
  activeLessons: [],
  lessonInstance: null
}

export const lessonReducer = (
  state: LessonTypes.LessonState = lessonInitialState,
  action: LessonTypes.LessonActions
): LessonTypes.LessonState => {
  switch (action.type) {
    case UserServiceActionTypes.LOGOUT:
      return lessonInitialState
    case LessonTypes.LessonActionTypes.SET_LESSON_INSTANCE:
      return {
        ...state,
        lessonInstance: action.routine
      }

    case LessonTypes.LessonActionTypes.GET_ACTIVE_LESSONS:
      return {
        ...state,
        activeLessons: action.activeLessons
      }

    case LessonTypes.LessonActionTypes.GET_LESSONS_TEMPLATES:
      return {
        ...state,
        lessonsTemplates: action.lessonsTemplates
      }

    case LessonTypes.LessonActionTypes.RESET_LESSON_INSTANCE:
      return {
        ...state,
        lessonInstance: null
      }

    case LessonTypes.LessonActionTypes.CHANGE_LESSON_INSTANCE_PROGRESS:
      return {
        ...state,
        lessonInstance: state.lessonInstance
          ? {
              ...state.lessonInstance,
              resumeAtActivityIndex: action.currentComponentIndex
            }
          : null
      }

    default:
      return state
  }
}
